var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "row row-cols-1 row-cols-md-3 gy-4 inner-gallery" },
        _vm._l(_vm.imgs, function (src, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "pic col",
              on: { click: () => _vm.showImg(index) },
            },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: { src: src, alt: "" },
              }),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("vue-easy-lightbox", {
        attrs: { moveDisabled: "", visible: _vm.visible, imgs: _vm.imgs },
        on: { hide: _vm.handleHide },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function () {
              return [_vm._v(" ")]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }